import React from "react";
import shortid from "shortid";
import { Table } from "react-bulma-components";
import { Box } from "react-bulma-components";
import { Button } from "react-bulma-components";
import { Form } from "react-bulma-components";


import Collapsible from "react-collapsible";
import { useDispatch } from "react-redux";
import { createSetContactDataAction } from "../../actions/dataActions";

function ContactInfoSection({ contactList, propertyName, includeAddress, showLicenceInfo}) {
  const dispatch = useDispatch();

  const handleChange = (e, index) => {
    let contact = contactList[index];
    contact[e.target.name] = e.target.value;
    updateContacts(contact, index);
  };

  const addContact = e => {
    let newContacts = [...contactList];
    newContacts.push({
      key: shortid.generate(),
      name: "",
      email: "",
      role: "",
      comments: "",
      address: "",
      licence_number: "",
      ni_number: "",
      licence_type: "",
      licence_held: 0,
      license_expiry_date: null,
      license_checked_date: null
    });
    dispatch(createSetContactDataAction({ [propertyName]: newContacts }));
  };

  const updateContacts = (contact, index) => {
    let newContacts = [...contactList];
    newContacts.splice(index, 1, contact);
    dispatch(createSetContactDataAction({ [propertyName]: newContacts }));
  };

  const removeContact = index => {
    let newContacts = [...contactList];
    newContacts.splice(index, 1);
    dispatch(createSetContactDataAction({ [propertyName]: newContacts }));
  };

  return (
    <div>
      <Table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Role</th>
            <th>Phone Number</th>
            <th>Email</th>
            {includeAddress && <th>Address</th>}
            {showLicenceInfo && <th>Comments</th>}
            {showLicenceInfo && <th>Licence Number</th>}
            {showLicenceInfo && <th>NI Number</th>}
            {showLicenceInfo && <th>Licence Type</th>}
            {showLicenceInfo && <th>Licence Held (Years)</th>}
            {showLicenceInfo && <th>Licence Expiry Date</th>}
            {showLicenceInfo && <th>Licence Checked Date</th>}
            <th></th>
          </tr>
        </thead>
        <tbody>
          {contactList
            .sort((a, b) => a.id > b.id)
            .map((item, index) => (
              <tr>
                <td>
                  <Form.Control>
                    <Form.Input
                      type="text"
                      value={item.name || ""}
                      name="name"
                      onChange={e => handleChange(e, index)}
                    />
                  </Form.Control>
                </td>
                <td>
                  <Form.Control>
                    <Form.Input
                      type="text"
                      value={item.role}
                      name="role"
                      onChange={e => handleChange(e, index)}
                    />
                  </Form.Control>
                </td>
                <td>
                  <Form.Control>
                    <Form.Input
                      type="text"
                      value={item.contact_number}
                      name="contact_number"
                      onChange={e => handleChange(e, index)}
                    />
                  </Form.Control>
                </td>
                <td>
                  <Form.Control>
                    <Form.Input
                      type="email"
                      value={item.email}
                      name="email"
                      onChange={e => handleChange(e, index)}
                    />
                  </Form.Control>
                </td>
                {includeAddress && (
                  <td>
                    <Form.Control>
                      <Form.Textarea
                        rows={2}
                        type="text"
                        value={item.address}
                        name="address"
                        onChange={e => handleChange(e, index)}
                      />
                    </Form.Control>
                  </td>
                )}
                <td>
                  <Form.Control>
                    <Form.Textarea
                      rows={2}
                      type="text"
                      value={item.comments}
                      name="comments"
                      onChange={e => handleChange(e, index)}
                    />
                  </Form.Control>
                </td>
                {showLicenceInfo &&
                <td>
                  <Form.Control>
                    <Form.Input
                      type={"text"}
                      name={"licence_number"}
                      value={item.licence_number}
                      onChange={e => handleChange(e, index)}
                    />
                  </Form.Control>
                </td>
                }
                {showLicenceInfo &&
                <td>
                  <Form.Control>
                    <Form.Input
                      type={"text"}
                      name={"ni_number"}
                      value={item.ni_number}
                      onChange={e => handleChange(e, index)}
                    />
                  </Form.Control>
                </td>
                }
                {showLicenceInfo &&
                <td>
                  <Form.Control>
                    <Form.Input
                      type={"text"}
                      name={"licence_type"}
                      value={item.licence_type}
                      onChange={e => handleChange(e, index)}
                    />
                  </Form.Control>
                </td>
                }
                {showLicenceInfo &&
                <td>
                  <Form.Control>
                    <Form.Input
                      type={"text"}
                      name={"licence_held"}
                      value={item.licence_held}
                      onChange={e => handleChange(e, index)}
                    />
                  </Form.Control>
                </td>
                }
                {showLicenceInfo &&
                <td>
                  <Form.Control>
                    <Form.Input
                      type={"date"}
                      value={item.licence_expiry_date}
                      name={"licence_expiry_date"}
                      onChange={e => handleChange(e, index)}
                    />
                  </Form.Control>
                </td>
                }
                {showLicenceInfo &&
                <td>
                  <Form.Control>
                    <Form.Input
                      type={"date"}
                      value={item.licence_checked_date}
                      name={"licence_checked_date"}
                      onChange={e => handleChange(e, index)}
                    />
                  </Form.Control>
                </td>
                }
                <td>
                  <Button
                    remove
                    onClick={() => removeContact(index)}
                    data-testid="remove-contact"
                  >
                    Remove
                  </Button>
                </td>
              </tr>
            ))}
        </tbody>
      </Table>
      <Button color="primary" onClick={addContact} data-testid="add-contact">
        Add Additional Contact
      </Button>
    </div>
  );
}

export default ContactInfoSection;
